import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useSuperAdminSinglePlan } from "../../../context/SuperAdmin/SinglePlanContext";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import ProfileRowSucript from "./ProfileRowSucript";

const SuscriptTable = () => {
  const { suscriptions } = useSuperAdminSinglePlan();
  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Organización</StyledTableCell>
            <StyledTableCell>Fecha de creación</StyledTableCell>
            <StyledTableCell>Fecha de inicio</StyledTableCell>
            <StyledTableCell>Fecha de expiración</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {suscriptions.length > 0 ? (
            suscriptions.map((suscr, index) => (
              <ProfileRowSucript
                key={suscr.id_suscripcion}
                suscription={suscr}
                i={index + 1}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuscriptTable;
